import { type ReactNode } from 'react';
import { ModalOverlay, ModalWrapper, type ModalProps } from '~/shared/components/modal/Modal';
import { FooterButtonContainer } from './buttons/FooterButtonContainer';
import { CancelButton } from './buttons/CancelButton';
import { FormRegistryProvider, useFormRegistry, type FormRegistryFormProps, type FormRegistryProviderProps } from './FormRegistryContext';
import type { FormSubmitButtonProps } from './buttons/FormSubmitButton';
import { SubmitButton, type SubmitButtonProps } from '../components/buttons/SubmitButton';

interface FormRegistryModal extends Omit<ModalProps, 'closeModal'>, FormRegistryFormProps, FormRegistryProviderProps {
	closeModal: () => void;
	submitButtonProps?: Omit<FormSubmitButtonProps, 'onSubmit'>;
	submitButton?: ReactNode;
	modalClassName?: string;
}

export function FormRegistryModal(props: FormRegistryModal) {
	return (
		<ModalOverlay {...props}>
			<FormRegistryProvider {...props}>
				<ModalWrapper
					{...props}
					className={props.modalClassName}
					footer={
						<FooterButtonContainer>
							<CancelButton onCancel={props.closeModal} />
							{props.submitButton ? props.submitButton : <FormRegistrySubmitButton {...props.submitButtonProps} />}
						</FooterButtonContainer>
					}
				>
					{props.children}
				</ModalWrapper>
			</FormRegistryProvider>
		</ModalOverlay>
	);
}

export function FormRegistrySubmitButton(props: Omit<SubmitButtonProps, 'onSubmit'>) {
	const { handleSubmit, isSubmitting } = useFormRegistry();

	return <SubmitButton isDisabled={isSubmitting} isPending={isSubmitting} onSubmit={handleSubmit} {...props} />;
}
